export enum StatusEnum {
    ADHERENT = "Adhérent",
    PROSPECT = "Prospect actif",
    ANNULE = "Ancien client",
    ARAFRAICHIR = "Non pertinent",
    SANSSUITE = "Autre prospect",
    MISSIONSPONCTUELLES = "Missions ponctuelles"
  }